import axios from 'axios';
import { getFirebase } from './customAuth';
import { getAppCheckToken } from './appCheck';
import { API_KEY } from '../config/apiConfig';

/**
 * Axios instance with automatic API name
 * @param {Object} config - Axios config object
 * @param {string} config.apiName - Name of the API to use
 * @returns {Promise} Axios response
 */
export const axiosWithApiName = async (config) => {
  try {
    const includeApiKey = config.includeApiKey || false;
    delete config.includeApiKey;
    const { ...axiosConfig } = config;
    const headers = {
      ...axiosConfig.headers,
    };
    if (includeApiKey) {
      headers.apiKey = API_KEY;
    }
    // const currentUser = getFirebase()?.auth()?.currentUser;
    // if (currentUser) {
    //   const token = (await currentUser.getIdToken()) || '';
    //   headers.Authorization = `Bearer ${token}`;
    // }
    const appCheckToken = (await getAppCheckToken()) || '';
    if (appCheckToken) {
      headers['X-Firebase-AppCheck'] = appCheckToken;
    }
    return await axios({
      ...axiosConfig,
      headers,
    });
  } catch (error) {
    // console.log('Error in axiosWithApiName:', error);
    // throw error;
  }
};

/**
 * GET request with automatic API name
 * @param {string} url - Request URL
 * @param {string} apiName - Name of the API to use
 * @param {Object} config - Additional axios config
 * @returns {Promise} Axios response
 */
export const getWithApiName = async (url, apiName, config = {}) => {
  return axiosWithApiName({
    method: 'GET',
    url,
    apiName,
    ...config,
  });
};

/**
 * POST request with automatic API name
 * @param {string} url - Request URL
 * @param {Object} data - Request data
 * @param {string} apiName - Name of the API to use
 * @param {Object} config - Additional axios config
 * @returns {Promise} Axios response
 */
export const postWithApiName = async (url, data, apiName, config = {}) => {
  let formattedUrl = url;
  const originalUrl = url;
  if (
    url &&
    typeof url === 'string' &&
    (url.includes('documentVaultAPI') ||
      url.includes('fileStorageApi') ||
      url.includes('documentEnhanced') ||
      url.includes('documentListEnhancedAdminView'))
  ) {
    formattedUrl = originalUrl.replace(
      'https://europe-west1-balwin-60c4a.cloudfunctions.net/sdk',
      'https://europe-west1-balwin-60c4a.cloudfunctions.net',
    );
  }
  return axiosWithApiName({
    method: 'POST',
    url: formattedUrl,
    data,
    apiName,
    ...config,
  });
};

/**
 * PUT request with automatic API name
 * @param {string} url - Request URL
 * @param {Object} data - Request data
 * @param {string} apiName - Name of the API to use
 * @param {Object} config - Additional axios config
 * @returns {Promise} Axios response
 */
export const putWithApiName = async (url, data, apiName, config = {}) => {
  return axiosWithApiName({
    method: 'PUT',
    url,
    data,
    apiName,
    ...config,
  });
};

/**
 * DELETE request with automatic API name
 * @param {string} url - Request URL
 * @param {string} apiName - Name of the API to use
 * @param {Object} config - Additional axios config
 * @returns {Promise} Axios response
 */
export const deleteWithApiName = async (
  url,
  apiName,
  config = {},
  data = {},
) => {
  const payload = {
    ...(data || {}),
  };
  let formattedUrl = url;
  const originalUrl = url;
  if (url && typeof url === 'string' && url.includes('salesAgentAPI')) {
    formattedUrl = originalUrl.replace(
      'https://europe-west1-balwin-60c4a.cloudfunctions.net/sdk',
      'https://europe-west1-balwin-60c4a.cloudfunctions.net',
    );
  }
  return axiosWithApiName({
    method: 'DELETE',
    url: formattedUrl,
    apiName,
    data: payload,
    ...config,
  });
};
